import React from 'react';
import styled from 'styled-components';

const LogoLight = require('../../assets/images/BST-logo.png');
const LogoDark = require('../../assets/images/BST-logo-dark.png');
const LogoBlue = require('../../assets/images/BST-logo-blue.png');

const BlyncSyncLogo = styled.img`
  width: ${(props) => {
    if (props.width) return `${props.width}px`;
    return '100%';
  }};
  height: auto;
`;

const BlyncSync = ({ color, width }) => (
  <BlyncSyncLogo
    src={(() => {
      switch (color) {
        case 'light':
          return LogoLight;
        case 'dark':
          return LogoDark;
        case 'blue':
          return LogoBlue;
        default:
          return LogoDark;
      }
    })()}
    alt="BST Logo"
    width={width}
  />
);

export default BlyncSync;
